import React from "react";
import {
    Segmented,
    Badge,
    Grid
} from "antd";

const NotificationFilter = ({
                                value,
                                onChange,
                                counts = {}
                            }) => {
    // Pleine largeur sur ordinateur ; en dessous, les 8 filtres gardent leur libellé et défilent.
    const screens = Grid.useBreakpoint();

    return (
        <div className="notification-filters">
        <Segmented
            block={!!screens.lg}
            value={value}
            onChange={onChange}
            options={[
                {
                    label:
                        `Toutes (${counts.all ?? 0})`,
                    value: "ALL"
                },
                {
                    label: (
                        <Badge
                            count={counts.unread ?? 0}
                            offset={[8, 0]}
                        >
                            <span>
                                Non lues
                            </span>
                        </Badge>
                    ),
                    value: "UNREAD"
                },
                {
                    label:
                        `Négociations (${counts.negotiation ?? 0})`,
                    value: "NEGOTIATION"
                },
                {
                    label:
                        `Offres (${counts.offer ?? 0})`,
                    value: "OFFER"
                },
                {
                    label:
                        `Accords (${counts.agreement ?? 0})`,
                    value: "AGREEMENT"
                },
                {
                    label:
                        `Paiements (${counts.payment ?? 0})`,
                    value: "PAYMENT"
                },
                {
                    label:
                        `Livraisons (${counts.delivery ?? 0})`,
                    value: "DELIVERY"
                },
                {
                    label:
                        `Archivées (${counts.archived ?? 0})`,
                    value: "ARCHIVED"
                }
            ]}
        />
        </div>
    );
};

export default NotificationFilter;